//==============================
// Hero Slider
//==============================

var pageHeroSlider = $('.page-hero .hero-media-slider');

pageHeroSlider.on('init', function(event, slick, direction) {
  $('.page-hero').removeClass('init');
});

pageHeroSlider.slick({
  dots: false,
  arrows: true,
  infinite: true,
  speed: 1000,
  autoplaySpeed: 5000,
  autoplay: true,
  slidesToShow: 1,
  draggable: false,
  touchThreshold: 10,
  responsive: [
    {
      breakpoint: 768,
      settings: {
        speed: 600,
        vertical: false
      }
    }
  ]
});
